import { Equal, TrendingDown, TrendingUp } from 'lucide-react';
import colors from 'theme/colors';

const percentFormat = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });

/** 38.9 => "38,9%" */
export const percent = (value) => `${percentFormat.format(value)}%`;

/** A tendência que a API escreve ("+37.5% vs período anterior") subiu? */
export const isIncrease = (trend) => typeof trend === 'string' && /^\+(?!0(\.0)?%)/.test(trend);

/** Lucro, prejuízo ou zero a zero: o que o `desfecho` da API vira na tela. */
export const OUTCOMES = {
    profit: { label: 'Lucro', color: colors.successDark, Icon: TrendingUp },
    loss: { label: 'Prejuízo', color: colors.dangerDark, Icon: TrendingDown },
    break_even: { label: 'Sem lucro nem prejuízo', color: colors.coralGrey, Icon: Equal },
};

export const outcomeOf = (desfecho) => OUTCOMES[desfecho] || OUTCOMES.break_even;

/** A margem sobre a receita líquida, em texto. Sem receita não há margem. */
export const marginText = (margem) => (
    margem === null || margem === undefined
        ? 'Sem receita líquida no período'
        : `Margem de ${percent(margem)} sobre a receita líquida`
);
